import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { _ti } from '@wephone-translation';
import { FlexBaseComponent } from '@wephone-core-ui';
import { SubscriptionPack } from '@wephone/services/subscription.service.i';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent extends FlexBaseComponent implements OnInit {
  form: FormGroup;
  subscriptionPacks: SubscriptionPack[] = [];
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate([ '/s/signin' ]);
  }
}
